<div class="form-modal" *ngIf="form">
  <h1 mat-dialog-title>{{'UPDATE_OFF_RECEPTION' | translate}}: {{documentNumber}}</h1>
  <div mat-dialog-content>
    <form [formGroup]="form" class="form-horizontal">
      <div class="form-group">
        <div class="col-sm-12">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPn1" (click)="collPn1 = !collPn1">
              <h5 class="panel-title">
                <i class="fas fa-tasks"></i>
                <strong>{{ 'BASE' | translate}}</strong>
                <i class="collapse-icon fas" [ngClass]="{'fa-caret-down': collPn1, 'fa-caret-up': !collPn1}"></i>
              </h5>
            </div>
            <div id="collPn1" class="panel-body no-horizontal-padding collapse in">
              <div class="form-group">
                <!-- Nº Rec. Menu-01 -->
                <div *ngIf="!hideReceptionNumber" class="col-md-3 col-sm-12">
                  <mat-form-field class="allwidth" [ngClass]="{ 'mat-input-invalid': formErrors.BuyerReceptionNumber }">
                    <mat-label *ngIf="!otisReceptionNumberValidation">{{ 'RECEPTION_NUMBER' | translate}}</mat-label>
                    <mat-label *ngIf="otisReceptionNumberValidation">{{ 'RECEPTION_NUMBER_MENU' | translate}}</mat-label>
                    <input *ngIf="!otisReceptionNumberValidation" matInput
                      (keyup)="dataChanged()" formControlName="BuyerReceptionNumber">
                    <input *ngIf="otisReceptionNumberValidation" matInput
                      (keyup)="dataChanged()" formControlName="BuyerReceptionNumber">
                  </mat-form-field>
                  <span *ngIf="formErrors.BuyerReceptionNumber" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.BuyerReceptionNumber">{{ formErrors.BuyerReceptionNumber }}</span>
                </div>
                <!-- Nº Guia -->
                <div class="col-md-3 col-sm-12">
                  <mat-form-field class="allwidth" [ngClass]="{ 'mat-input-invalid': formErrors.TransportDocumentNumber }">
                    <mat-label>{{ 'GUIDE_NUMBER' | translate}}</mat-label>
                    <input matInput (keyup)="dataChanged()"
                      formControlName="TransportDocumentNumber">
                  </mat-form-field>
                  <span *ngIf="formErrors.TransportDocumentNumber" class="field-validation-valid text-danger"
                    [translate] [translateParams]="formErrorsParam.TransportDocumentNumber">{{
                    formErrors.TransportDocumentNumber }}</span>
                </div>
                <!-- Linha -->
                <div class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'LINE_NUMBER' | translate}}</mat-label>
                    <input matInput (keyup)="dataChanged()"
                      formControlName="OriginalLineNumber">
                  </mat-form-field>
                </div>
                <!-- Código artigo -->
                <div class="col-md-4 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'ARTICLE' | translate}}</mat-label>
                    <input matInput (keyup)="dataChanged()" formControlName="BuyerProductCode">
                  </mat-form-field>
                </div>
                <!-- Espaço -->
                <div class="col-md-12 col-xs-12 spacer-bottom-xs"></div>
                <!-- Descrição -->
                <div class="col-md-6 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'DESCRIPTION' | translate}}</mat-label>
                    <input matInput (keyup)="dataChanged()"
                      formControlName="ProductDescription">
                  </mat-form-field>
                </div>
                <!-- Qtd. Encomendada -->
                <div class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'ORDERED_QUANTITY' | translate}}</mat-label>
                    <input matInput (keyup)="dataChanged()"
                      formControlName="RequestedQuantity">
                  </mat-form-field>
                </div>
                <!-- Qtd. recebida anteriormente -->
                <div class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'RECEIVED_QUANTITY_PREVIOUSLY' | translate}}</mat-label>
                    <input matInput (keyup)="dataChanged()"
                      formControlName="ReceivedQuantityPreviously" (change)="dataChanged('ReceivedQuantityPreviously', $event)">
                  </mat-form-field>
                </div>

                <!-- Qtd. recebida -->
                <div class="col-md-2 col-sm-12" [ngClass]="{ 'mat-input-invalid': formErrors.DeliveredQuantity }">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'RECEIVED_QUANTITY' | translate}}</mat-label>
                    <input matInput (keyup)="dataChanged()"
                      formControlName="DeliveredQuantity" (input)="receivedQuantityChange($event.target.value)">
                  </mat-form-field>
                  <span *ngIf="formErrors.DeliveredQuantity" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.DeliveredQuantity">{{ formErrors.DeliveredQuantity }}</span>
                </div>

                <!-- Espaço -->
                <div *ngIf="showReturnedQuantity" class="col-md-12 col-xs-12 spacer-bottom-xs"></div>

                <!-- Qtd. devolvida anteriormente -->
                <div *ngIf="showReturnedQuantity" class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'RETURNED_QUANTITY_PREVIOUSLY' | translate}}</mat-label>
                    <input matInput (keyup)="dataChanged()"
                      formControlName="ReturnedQuantityPreviously" (change)="dataChanged('ReTurnedQuantityPreviously', $event)">
                  </mat-form-field>
                </div>
                <!-- Qtd. devolvida -->
                <div *ngIf="showReturnedQuantity" class="col-md-2 col-sm-12" [ngClass]="{ 'mat-input-invalid': formErrors.DeliveredQuantity }">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'RETURNED_QUANTITY' | translate}}</mat-label>
                    <input matInput (keyup)="dataChanged('ReturnedQuantity')"
                      formControlName="ReturnedQuantity">
                  </mat-form-field>
                  <span *ngIf="formErrors.ReturnedQuantity" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.ReturnedQuantity">{{ formErrors.ReturnedQuantity }}</span>
                </div>

                <td *ngIf="showReturnedQuantity && showReturnReasons" class="col-md-2 col-sm-12" [ngClass]="{ 'mat-input-invalid': formErrors.ReturnReasonID }">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'RETURN_REASON' | translate}}</mat-label>
                    <mat-select formControlName="ReturnReasonID" (selectionChange)="onSelectReturnReasonID($event.value);dataChanged('ReturnReasonID')"
                      [ngClass]="{ 'mat-input-invalid': formErrors.ReturnReasonID}">
                      <mat-option></mat-option>
                      <mat-option *ngFor="let item of returnReasonsList" [value]="item.ID">{{item.ItemName}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </td>

                <div *ngIf="showUOMCodeOnReception" class="col-md-2 col-sm-12" [ngClass]="{ 'mat-input-invalid': formErrors.DeliveredQuantity }">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'UNIT_DATATABLE_HEAD' | translate}}</mat-label>
                    <input matInput
                      formControlName="OrderedQuantityUOMCode">
                  </mat-form-field>
                  <span *ngIf="formErrors.ReturnedQuantity" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.ReturnedQuantity">{{ formErrors.ReturnedQuantity }}</span>
                </div>
                <div *ngIf="associateInvoiceToReception" class="col-md-2 col-sm-12" [ngClass]="{ 'mat-input-invalid': formErrors.InvoiceID }">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'INVOICE' | translate}}</mat-label>
                    <input matInput formControlName="InvoiceNumber" class="one">
                      <i matSuffix class="glyphicon glyphicon-new-window" (click)="selectAssociateInvoice()"></i>
                  </mat-form-field>
                  <span *ngIf="formErrors.ReturnedQuantity" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.ReturnedQuantity">{{ formErrors.ReturnedQuantity }}</span>
                </div>
                <div *ngIf="showCloseLine" class="col-md-2 col-sm-12">
                  <mat-checkbox 
                  formControlName="Closed" (change)="dataChanged()"> {{ 'LINE_CLOSED' | translate}} </mat-checkbox>
                  <span *ngIf="formErrors.ReturnedQuantity" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.ReturnedQuantity">{{ formErrors.ReturnedQuantity }}</span>
                </div>

                <!-- Espaço -->
                <div class="col-md-12 col-xs-12 spacer-bottom-xs"></div>
                <!-- Aval data -->
                <div *ngIf="isReceptionHasExtendedEvals" class="col-md-4 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'DATE_EVALUATION' | translate}}</mat-label>
                    <mat-select formControlName="DeliveryDateEval"
                      (selectionChange)="onSelectEvalDateID($event.value); dataChanged()">
                      <mat-option></mat-option>
                      <mat-option *ngFor="let item of deliveryDateEvalList" [value]="item.ItemCode">{{item.ItemName}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <!-- Aval qtd. -->
                <div *ngIf="isReceptionHasExtendedEvals" class="col-md-4 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'QTD_EVALUATION' | translate}}</mat-label>
                    <mat-select formControlName="ReceivedQuantityEval"
                      (selectionChange)="onSelectEvalQtdID($event.value); dataChanged()">
                      <mat-option></mat-option>
                      <mat-option *ngFor="let item of receivedQuantityEvalList" [value]="item.ItemCode">{{item.ItemName}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <!-- Aval prod. -->
                <div *ngIf="isReceptionHasExtendedEvals" class="col-md-4 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'PROD_EVALUATION' | translate}}</mat-label>
                    <mat-select formControlName="ProductEval"
                      (selectionChange)="onSelectEvalProdID($event.value); dataChanged()">
                      <mat-option></mat-option>
                      <mat-option *ngFor="let item of productEvalList" [value]="item.ItemCode">{{item.ItemName}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <!-- Avaliação por defeito -->
                <div *ngIf="!isReceptionHasExtendedEvals" class="col-md-12 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'EVALUATION' | translate}}</mat-label>
                    <mat-select formControlName="Evaluation"
                      (selectionChange)="onSelectEvaluation($event.value); dataChanged()">
                      <mat-option></mat-option>
                      <mat-option *ngFor="let item of evaluationEvalList" [value]="item.ItemCode">{{item.ItemName}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <!-- Espaço -->
                <div class="col-md-12 col-xs-12 spacer-bottom-xs"></div>
                <!-- Observações -->
                <div class="col-md-12 col-sm-12">
                  <mat-form-field class='allwidth'>
                    <mat-label>{{ 'NOTES' | translate}}</mat-label>
                    <textarea matInput (keyup)="dataChanged()" formControlName="Notes"
                      class="no-resize" rows="3"></textarea>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div mat-dialog-actions>
    <div class="full-width text-right">
      <button type="button" class="btn btn-default" (click)="resetForm();dialogRef.close(null)">
        <i class="fas fa-ban"></i>&nbsp;{{'BUTTON.CANCEL' | translate}}
      </button>
      <button *ngIf="allowEdit" type="button" class="btn btn-primary" (click)="save()" [disabled]="!changed">
        <i class="far fa-save"></i>&nbsp;{{'BUTTON.SAVE' | translate}}
      </button>
    </div>
  </div>
</div>